import { AxiosError, AxiosRequestConfig } from 'axios';
import { getApiEndpoint, IEnpointApis } from 'library/Apis';
import ApiService from 'services/ApiService';
import { ErrorAPI, ResponseAPI } from './interfaces';

export async function getEvento<T>(
  endpoint: keyof IEnpointApis,
  path: string,
  config?: AxiosRequestConfig
): Promise<ResponseAPI<T>> {
  const url = `${getApiEndpoint(endpoint)}${path}`;
  try {
    const response = await ApiService.get<T>(url, config);
    return {
      data: response.data,
      response,
    };
  } catch (error) {
    return {
      fail: error
    };
  }
}

export async function get<T>(
  endpoint: keyof IEnpointApis,
  path: string,
  config?: AxiosRequestConfig
): Promise<ResponseAPI<T>> {
  const url = `${getApiEndpoint(endpoint)}${path}`;
  try {
    const response = await ApiService.get<T>(url, config);
    return {
      data: response.data,
      response,
    };
  } catch (error) {
    return {
      fail: (error as AxiosError<ErrorAPI>).response?.data,
    };
  }
}

export async function post<T>(
  endpoint: keyof IEnpointApis,
  path: string,
  data?: any,
  config?: AxiosRequestConfig
): Promise<ResponseAPI<T>> {
  try {
    const url = `${getApiEndpoint(endpoint)}${path}`;
    const response = await ApiService.post<T>(url, data, config);
    return {
      data: response.data,
      response,
    };
  } catch (error) {
    return {
      fail: (error as AxiosError<ErrorAPI>).response?.data,
    };
  }
}

export async function put<T>(
  endpoint: keyof IEnpointApis,
  path: string,
  data?: any,
  config?: AxiosRequestConfig
): Promise<ResponseAPI<T>> {
  const url = `${getApiEndpoint(endpoint)}${path}`;
  try {
    const response = await ApiService.put<T>(url, data, config);
    return {
      data: response.data,
      response,
    };
  } catch (error) {
    return {
      fail: (error as AxiosError<ErrorAPI>).response?.data,
    };
  }
}

export async function del<T>(
  endpoint: keyof IEnpointApis,
  path: string,
  config?: AxiosRequestConfig
): Promise<ResponseAPI<T>> {
  const url = `${getApiEndpoint(endpoint)}${path}`;
  try {
    const response = await ApiService.delete<T>(url, config);
    return {
      data: response.data,
      response,
    };
  } catch (error) {
    return {
      fail: (error as AxiosError<ErrorAPI>).response?.data,
    };
  }
}
